import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { GroupMembership } from '@/types/models';

const COLLECTION = 'group_memberships';

function docToMembership(
  d: { id: string },
  data: Record<string, unknown>,
): GroupMembership {
  return {
    id: d.id,
    userId: data.userId as string,
    groupId: data.groupId as string,
    churchId: data.churchId as string,
    isGroupAdmin: (data.isGroupAdmin as boolean) ?? false,
  };
}

export async function getMembershipsByGroup(
  groupId: string,
): Promise<GroupMembership[]> {
  const q = query(
    collection(db, COLLECTION),
    where('groupId', '==', groupId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToMembership(d, d.data()));
}

export async function getMembershipsByChurch(
  churchId: string,
): Promise<GroupMembership[]> {
  const q = query(
    collection(db, COLLECTION),
    where('churchId', '==', churchId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToMembership(d, d.data()));
}

export async function getMembershipsByUser(
  userId: string,
  churchId: string,
): Promise<GroupMembership[]> {
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    where('churchId', '==', churchId),
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => docToMembership(d, d.data()));
}

export async function addMembership(
  data: Omit<GroupMembership, 'id'>,
): Promise<string> {
  const ref = await addDoc(collection(db, COLLECTION), {
    userId: data.userId,
    groupId: data.groupId,
    churchId: data.churchId,
    isGroupAdmin: data.isGroupAdmin ?? false,
  });
  return ref.id;
}

export async function updateMembership(
  id: string,
  data: Partial<Pick<GroupMembership, 'isGroupAdmin'>>,
): Promise<void> {
  await updateDoc(doc(db, COLLECTION, id), data);
}

export async function removeMembership(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTION, id));
}
